"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TestFileUploader = /** @class */ (function () {
    function TestFileUploader(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.errorChance, errorChance = _c === void 0 ? 0.5 : _c;
        this.errorChance = errorChance;
    }
    TestFileUploader.prototype.upload = function (file, _a) {
        var onProgress = _a.onProgress, onComplete = _a.onComplete, onError = _a.onError;
        var progress = 0;
        if (Math.random() <= this.errorChance) {
            onError('An error occured.');
        }
        var interval = 100 + Math.floor(Math.random() * 150);
        var intervalId = setInterval(function () {
            progress = Math.min(progress + 10, 100);
            onProgress(progress);
            if (progress >= 100) {
                onComplete('dev_platform/6sense/named_accounts/0e0981_test_account_list_segments.csv');
                clearInterval(intervalId);
            }
        }, interval);
        return function () {
            clearInterval(intervalId);
        };
    };
    return TestFileUploader;
}());
exports.default = TestFileUploader;
